<div style="display: inline-flex; align-items: center; gap: 4px;">
  <span class="app-toolbar-title" *ngIf="editingDetails === 'PROJECT'">{{project.name}}</span>

  <!-- Draft title: click-to-edit -->
  <ng-container *ngIf="editingDetails === 'DRAFT' && draft">
    <span class="app-toolbar-title toolbar-inline-title" *ngIf="!editingDraftTitle" (click)="startEditDraftTitle()">{{draft.title || project.name}}</span>
    <input *ngIf="editingDraftTitle" class="toolbar-title-input" #draftTitleInput
           [value]="draft.title || ''"
           maxlength="40"
           (blur)="commitDraftTitle(draftTitleInput.value)"
           (keydown.enter)="draftTitleInput.blur()"
           (keydown.escape)="cancelDraftTitle(draftTitleInput)">
  </ng-container>

  <!-- Book title: click-to-edit -->
  <ng-container *ngIf="editingDetails === 'BOOK' && book">
    <span class="app-toolbar-title toolbar-inline-title" *ngIf="!editingBookTitle" (click)="startEditBookTitle()">{{book.title || project.name}}</span>
    <input *ngIf="editingBookTitle" class="toolbar-title-input" #bookTitleInput
           [value]="book.title || ''"
           maxlength="40"
           (blur)="commitBookTitle(bookTitleInput.value)"
           (keydown.enter)="bookTitleInput.blur()"
           (keydown.escape)="cancelBookTitle(bookTitleInput)">
  </ng-container>

  <ng-container *ngIf="editingDetails==='DRAFT' || editingDetails==='BOOK'">
    <button *ngIf="!displaySettings" mat-icon-button (click)="displaySettings = !displaySettings; onDataChange();">
      <mat-icon style="color: white" i18n-title="@@Show Settings" title="Show Settings">settings</mat-icon>
    </button>
  </ng-container>
</div>
